export const studentGlobalLocations = [
    'school',
    'user-management',
    'student',
    'student-comment',
    'enrollment',
    'card',
    'cardType',
    'reservation',
    'reservationStatus',
    'payment',
    'paymentType',
    'paymentItem',
    'lesson',
    'lessonStatus',
    'invoice',
    'invoiceStatus',
    'event',
    'eventReservation'
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/constants/student.locations.constants.ts